<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  label: { type: [String, Number], default: '' },
  variant: { type: String, default: 'solid' },
  size: { type: String, default: 'sm' },
  icon: { type: [String, Object, Function], default: '' },
  trailingIcon: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
  color: { type: String, default: 'onyx' },
});

const emit = defineEmits(['click']);
</script>

<template>
  <Button
    :variant="variant"
    :color="color"
    :size="size"
    :icon="icon"
    :trailing-icon="trailingIcon"
    :is-loading="isLoading"
    v-bind="$attrs"
    @click="event => emit('click', event)"
  >
    <slot>{{ label }}</slot>
  </Button>
</template>
